module.exports = __webpack_public_path__ + "static/erickson1-4265befbb8324feabc5a649eb617c48b.jpg";